var _rect, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#D8F3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4588 49.2666V49.2669H66.4587C66.4587 53.9733 67.6459 58.5689 69.87 62.7246C65.5837 61.8439 61.1795 61.932 56.9445 63.0373C56.8855 63.0525 56.8265 63.0681 56.7676 63.0839C45.4226 66.1238 38.69 77.7851 41.7299 89.1301C42.969 93.7545 45.6406 97.6125 49.1392 100.355C47.4804 104.479 47.0958 109.156 48.3349 113.78C51.3748 125.125 63.036 131.858 74.381 128.818L74.3814 128.818L74.3815 128.818C82.2812 126.701 88.9294 121.208 92.8638 113.548C94.3185 110.715 95.3581 107.672 95.9726 104.521C96.3872 104.547 96.8053 104.56 97.2265 104.56C99.3172 104.56 101.332 104.234 103.222 103.63C103.679 107.839 104.873 111.917 106.781 115.633C110.707 123.276 117.333 128.761 125.209 130.888L125.263 130.903C136.608 133.943 148.269 127.211 151.309 115.866C152.548 111.241 152.164 106.565 150.505 102.44C154.004 99.6982 156.676 95.84 157.915 91.2152C160.955 79.8702 154.223 68.2089 142.878 65.169C142.838 65.1583 142.798 65.1479 142.759 65.1375L142.691 65.1199C138.496 64.0267 134.135 63.9313 129.888 64.7868C132.832 60.2055 134.448 54.9741 134.51 49.5872C134.511 49.4805 134.512 49.3737 134.512 49.2666C134.512 37.5214 124.991 28 113.246 28C108.458 28 104.04 29.5821 100.485 32.2519C96.9311 29.5821 92.513 28 87.7253 28C75.9802 28 66.4588 37.5214 66.4588 49.2666Z",
    fill: "#63CF99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.344 96.8062C101.039 111.055 94.8185 146.642 64.375 175",
    stroke: "#63CF99",
    strokeWidth: 10.4259
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.9023,
    cy: 79.3354,
    r: 4.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.283,
    cy: 79.3354,
    r: 4.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisability);
export default __webpack_public_path__ + "static/media/disability.8b7be9c5296626d2c26656fb7dd1c1ef.svg";
export { ForwardRef as ReactComponent };